import { isAmountValid } from "../../utils/validations";
import { MAX_STRING_LENGTH_50 } from "../../utils/constants";

interface Field {
  id: string;
  required?: boolean;
  type?: string;
}

interface FormValues {
  [key: string]: any;
}

interface FormErrors {
  [key: string]: string;
}

export const getFormErrors = (fields: Field[], formValues: FormValues): FormErrors => {
  if (!formValues) {
    return {};
  }

  const form_errors: FormErrors = {};

  fields.forEach((field) => {
    const id = field.id;
    const field_value = formValues[id];
    let error = "";

    if (!field.required) {
      error = "";
    } else if (field.type === "number") {
      error = !field_value
        ? "Please enter a valid number"
        : !isAmountValid(field_value)
        ? "Please enter only digit"
        : "";
    } else if (field.type === "upload") {
      error = !field_value || field_value.length < 1 
        ? "image are required" 
        : "";
    } else {
      error =
        field_value?.trim() === ""
          ? `${id} is required`
          : field_value?.length > MAX_STRING_LENGTH_50
          ? `Cannot be more than ${MAX_STRING_LENGTH_50} characters`
          : "";
    }

    if (error) {
      form_errors[id] = error;
    }
  });

  return form_errors;
};